import React from "react";
import { HardDrive, Loader2, RefreshCw } from "lucide-react";
import { useStorage } from "./storage/useStorage";
import { CollectionsTable, ArticlesTable } from "./storage/StorageBits";
import { TrimColumn } from "./storage/TrimColumn";

/** Capacity → Storage: per-collection sizes, articles by status, "Trim now". */
export default function StoragePanel() {
  const s = useStorage();
  const { data, err } = s;
  return (
    <section data-testid="storage-panel" className="border border-zinc-800 rounded-sm bg-zinc-950/30">
      <header className="flex items-center gap-2 px-5 py-3 border-b border-zinc-800">
        <HardDrive size={14} className="text-amber-500" />
        <h2 className="text-sm font-semibold uppercase tracking-wider text-zinc-100">Storage</h2>
        <button type="button" onClick={s.load} data-testid="storage-refresh" className="ml-auto text-zinc-500 hover:text-zinc-200"><RefreshCw size={13} /></button>
      </header>
      <p className="text-xs text-zinc-500 px-5 py-3 border-b border-zinc-800 leading-relaxed">
        Articles live 14 days hot → 14 days archived (noindex) → 14 days as a 410 tombstone → deleted. Raw source text is dropped after the rewrite, tombstones keep only slug + status, and log collections are swept daily.
        {data?.db?.free_mb > 20 && <span className="text-amber-400"> Mongo holds {data.db.free_mb} MB of reusable free space — it is reused by new writes; run <code>compact</code> only if disk itself is tight.</span>}
      </p>
      {!data && !err && <div className="p-5 text-xs text-zinc-500 flex items-center gap-2"><Loader2 size={12} className="animate-spin" /> loading…</div>}
      {err && <div className="p-5 text-xs text-red-400 mono">{err}</div>}
      {data && (
        <div className="p-5 grid grid-cols-1 lg:grid-cols-3 gap-6">
          <CollectionsTable data={data} />
          <ArticlesTable rows={data.articles_by_status} />
          <TrimColumn s={s} />
        </div>
      )}
    </section>
  );
}
